import { ReactNode } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditIcon from '@mui/icons-material/Edit';
import EventRoundedIcon from '@mui/icons-material/EventRounded';

import { Box, BoxProps, Tooltip } from '@sbv-clients/ui-shared';

const iconMap = {
  pencil: EditIcon,
  calendar: EventRoundedIcon,
  dropdown: ArrowDropDownIcon,
};

export const HoverIconCell = ({
  value,
  icon,
  editable,
  onIconClick,
  showTooltip = false,
  sx,
}: {
  value: ReactNode;
  icon: 'pencil' | 'dropdown' | 'calendar';
  editable: boolean;
  onIconClick?: () => void;
  showTooltip?: boolean;
  sx?: BoxProps;
}) => {
  const title = showTooltip ? value : '';

  if (!editable) {
    const textBox = (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          ...sx,
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {value}
        </Box>
      </Box>
    );
    if (showTooltip)
      return (
        <Tooltip title={title} placement="bottom" arrow>
          {textBox}
        </Tooltip>
      );
    return textBox;
  }

  const Icon = iconMap[icon];
  const cell = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        ...sx,
      }}
    >
      <Box
        sx={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          flexShrink: 1,
          minWidth: 0,
        }}
      >
        {value}
      </Box>

      <Box
        onClick={(e) => {
          if (onIconClick) {
            e.stopPropagation();
            onIconClick();
          }
        }}
        sx={{
          width: 0,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'gray',
          cursor: 'pointer',
          overflow: 'hidden',
          '&:hover, .MuiDataGrid-cell:hover &': {
            width: 25,
          },
        }}
      >
        <Icon fontSize="small" />
      </Box>
    </Box>
  );

  if (showTooltip)
    return (
      <Tooltip title={title} placement="bottom" arrow>
        {cell}
      </Tooltip>
    );
  return cell;
};
